import * as tslib_1 from "tslib";
import { DxControlPointInstance } from "./dx-control-point-instance";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
let DxControlPointChainInstance = class DxControlPointChainInstance {
};
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], DxControlPointChainInstance.prototype, "code", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], DxControlPointChainInstance.prototype, "finishDateTime", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointChainInstance.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], DxControlPointChainInstance.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointChainInstance.prototype, "objectId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointChainInstance.prototype, "objectTypeId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxControlPointChainInstance.prototype, "ord", void 0);
tslib_1.__decorate([
    jsonArrayMember(DxControlPointInstance, { isRequired: true }),
    tslib_1.__metadata("design:type", Array)
], DxControlPointChainInstance.prototype, "points", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, isRequired: true }),
    tslib_1.__metadata("design:type", Date)
], DxControlPointChainInstance.prototype, "startDateTime", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxControlPointChainInstance.prototype, "supervisorEmail", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxControlPointChainInstance.prototype, "supervisorLogin", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxControlPointChainInstance.prototype, "supervisorName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxControlPointChainInstance.prototype, "supervisorPosition", void 0);
DxControlPointChainInstance = tslib_1.__decorate([
    jsonObject()
], DxControlPointChainInstance);
export { DxControlPointChainInstance };
